<canvas
  style="
    width: inherit;
    min-width: inherit;
    max-width: inherit;
    height: inherit;
    min-height: inherit;
    max-height: inherit;
  "
  #lottieAnimationCanvas
  class="lottie-animation-canvas"
></canvas>
